document.addEventListener('DOMContentLoaded', () => {
    const trigger = document.querySelector('[data-open-search-modal]');
    if (!trigger) return;

    const dialogComponent = document.querySelector('dialog-component#search-modal');
    if (!dialogComponent) return;

    const nativeDialog = dialogComponent.querySelector('dialog');

    const openSearchModal = () => {
        // 1) Пробуємо API web-component’а, якщо воно є
        if (typeof dialogComponent.openDialog === 'function') {
            dialogComponent.openDialog();
            return;
        }

        // 2) Пробуємо кинути кастомну подію (якщо dialog.js на неї слухає)
        const evt = new CustomEvent('openDialog', { bubbles: true });
        dialogComponent.dispatchEvent(evt);

        // 3) Фолбек — нативний <dialog>
        if (nativeDialog && typeof nativeDialog.showModal === 'function') {
            nativeDialog.showModal();
        } else if (nativeDialog) {
            nativeDialog.setAttribute('open', 'open');
        }
    };

    trigger.addEventListener('click', openSearchModal);
});
